/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "components/ButtonUse";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import httpClientReq from "services/httpClient";
// import { Button } from "@mui/material";
// Data

// Dashboard components

function EditBmGuide() {
  const [key, setKey] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState("");
  const [imageUrls, setImageUrls] = useState([]);

  const { _id } = useParams();
  const location = useLocation();

  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const response = await httpClientReq.get(
        `/bodyData/getBodyDataMeasurementGuide?bodyDataId=${_id}`
      );
      const data = await response.data;
      if (data && data.data && data.data.image) {
        setImageUrls(data.data.image);
      } else {
        console.error("Invalid API response or missing image data");
      }
      if (response?.data?.data?.bodyData || []) {
        setKey(data.data.key);
        setTitle(data.data.title);
        setDescription(data.data.description);
        setFile(data.data.file);
      } else {
        console.error("Invalid API response or missing data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchData(_id);
    }
    console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  const handleInputChange = (e) => {
    setKey(e.target.value);
  };

  const handleInputChangetitle = (e) => {
    setTitle(e.target.value);
  };

  const handleInputChangetidescription = (e) => {
    setDescription(e.target.value);
  };

  const handleInputChangeFile = (e) => {
    if (e.target.files.length > 0) {
      // Access the first selected file
      setFile(e.target.files[0]);
    }
  };

  // -----------------------------------------PUT API------------------------------------------//
  // const { _id } = useParams();
  // const [_id1, set_id1] = useState("");

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const area = {
  //     key,
  //     file,
  //     description,
  //     title,
  //   };

  //   try {
  //     const requestOptions = {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(area),
  //     };

  //     const response = await fetch(
  //       `https://jumunona.onrender.com/admin/bodyData/updateBodyDataMesurementGuide/${_id}`,
  //       requestOptions
  //     );
  //     // console.log(_id, "ggggggggggggggggggg");
  //     if (!response.ok) {
  //       const error = await response.text();
  //       throw new Error(error);
  //     }
  //     const data = await response.json();
  //     console.log(data, "ggggggggggggggggggggggg");
  //     set_id1("");
  //     setKey("");
  //     setTitle("");
  //     setErrorMessage("");
  //     setDescription("");
  //     setFile("");
  //   } catch (error) {
  //     // setErrorMessage(error.message || "An error occurred while updating data");
  //     // console.error("There was an error!", error);
  //   }
  // };

  // const handleDeleteImage = (index) => {
  //   const updatedImages = [...imageUrls];
  //   updatedImages.splice(index, 1);
  //   setImageUrls(updatedImages);
  // };

  // const handleImageUpload = (event) => {
  //   const files = Array.from(event.target.files);
  //   const urls = files.map((file) => URL.createObjectURL(file));
  //   setImageUrls((prevUrls) => [...prevUrls, ...urls]);
  // };

  const [_id1, set_id1] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const area = {
      key,
      file,
      description,
      title,
    };

    try {
      const formData = new FormData();
      formData.append("key", key);
      formData.append("file", file);
      formData.append("description", description);
      formData.append("title", title);
      console.log(area, "File))))");

      const requestOptions = {
        method: "PUT",
        // body: formData,
        body: JSON.stringify(area),
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/updateBodyDataMesurementGuide/${_id}`,
        requestOptions
      );

      if (!response.ok) {
        const error = await response.text();
        throw new Error(error);
      }

      const data = await response.json();
      console.log(data);
      set_id1("");
      setKey("");
      setTitle("");
      setErrorMessage("");
      setDescription("");
      setFile("");
    } catch (error) {
      console.error("Error updating data:", error);
      setErrorMessage(error.message || "An error occurred while updating data");
    }
  };

  const handleDeleteImage = (index) => {
    const updatedImages = [...imageUrls];
    updatedImages.splice(index, 1);
    setImageUrls(updatedImages);
  };
  const handleImageUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const imageUrl = URL.createObjectURL(selectedFile);
      setImageUrls((prevImageUrls) => [...prevImageUrls, imageUrl]);

      setFile(selectedFile);
    } else {
      console.error("No file selected.");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Type"
                value={key}
                onChange={handleInputChange}
                variant="outlined"
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Title"
                value={title}
                onChange={handleInputChangetitle}
                variant="outlined"
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Description"
                value={description}
                onChange={handleInputChangetidescription}
                variant="outlined"
              />

              {/* <TextField
                type="file"
                sx={{ width: "20vw" }}
                fullWidth
                onChange={(e) => handleInputChangeFile(e)}
              /> */}
              {/* <div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {imageUrls.map((imageUrl, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <img
                        src={imageUrl}
                        alt={`Image ${index + 1}`}
                        style={{ width: "100px", height: "auto", margin: "10px" }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDeleteImage(index)}
                      >
                        &#x2716;
                      </span>
                    </div>
                  ))}
                </div>
                <input type="file" onChange={handleImageUpload} />
              </div> */}
            </div>
            <div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {imageUrls.map((imageUrl, index) => (
                  <div key={index} style={{ position: "relative" }}>
                    <img
                      src={imageUrl}
                      alt={`Image ${index + 1}`}
                      style={{ width: "100px", height: "auto", margin: "10px" }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleDeleteImage(index)}
                    >
                      &#x2716;
                    </span>
                  </div>
                ))}
              </div>
              <TextField type="file" onChange={handleImageUpload} style={{ marginTop: "4%" }} />
              {errorMessage && <div>Error: {errorMessage}</div>}
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10vh" }}
            >
              {/* <span>Image</span>
              <label htmlFor="profile_pic">
                <span
                  style={{
                    background: "crimson",
                    padding: "10px",
                    borderRadius: "10px",
                    fontSize: "small",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Choose Image
                </span>
              </label>
              <input id="profile_pic" style={{ display: "none" }} type="file" /> */}
            </div>
          </div>
          <div style={{ textAlign: "center", color: "red" }}>
            <span
              className="bg-red-700 rounded-md w-[10vw] cursor-pointer
             p-2 border-none outline-none ml-[1vw] text-white  text-sm"
              onClick={handleSubmit}
            >
              Submit
            </span>
          </div>
        </form>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default EditBmGuide;
